export default __webpack_public_path__ + "static/media/capsule-opened.a7fa3afe.png";